<script>
import { defineComponent } from 'vue'
import ClientStatusIcon from './clientStatusIcon.vue'

export default defineComponent({
    name: 'locationInfoWindow',
    components: { ClientStatusIcon },
    props: {
        data: Object,
        name: String,
        computedIconColor: String
    },
    data() {
        return {
            t_connection: Lang.langGet('Connection'),
            t_connect_failure_errors: Lang.langChoice('Error|Errors', this.data.connect_failures.errors),
            t_connect_failure_warnings: Lang.langChoice('Warning|Warnings', this.data.connect_failures.warnings),
            t_for_players: Lang.langChoice('for 1 player.|for :count players.', this.data.players),
            t_player_disabled: Lang.langChoice('The player is disabled.|All players are disabled.', this.data.players),
            t_fatal_errors: Lang.langChoice('Fatal Error|Fatal Errors', this.data.fatals),
            t_errors: Lang.langChoice('Error|Errors', this.data.errors),
            t_warnings: Lang.langChoice('Warning|Warnings', this.data.warnings),
            t_show_plan: Lang.langGet('Show plan'),

            t_disabled: Lang.langGet('Disabled'),
            t_status: Lang.langGet('Status')
        }
    },
    computed: {
        locationDataEmpty() {
            return this.data.latitude == undefined || this.data.longitude == undefined
        },
        somePlayersActive() {
            return this.data.inactive !== this.data.players
        },
        connectionStatus() {
            if (!this.somePlayersActive) return undefined

            if (this.data.connect_failures.errors > 0) {
                return 'red'
            } else if (this.data.connect_failures.warnings > 0) {
                return 'orange'
            } else {
                return 'green'
            }
        },
        planEmpty() {
            return !this.data.plan || this.data.plan.length === 0
        },
        moreThanOneLocationId() {
            return this.data.location_id?.length > 1
        }
    },
    created() {
        if (this.data.location_id != null && !Array.isArray(this.data.location_id)) {
            this.data.location_id = [this.data.location_id]
        }
        if (this.data.name != null && !Array.isArray(this.data.name)) {
            this.data.name = [this.data.name]
        }
        if (this.data.name != null && this.data.location_id != null) {
            var list = [];
            for (var j = 0; j < this.data.name.length; j++)
                list.push({'n': this.data.name[j], 'l': this.data.location_id[j]});

            list.sort(function (a, b) {
                return ((a.n < b.n) ? -1 : ((a.n == b.n) ? 0 : 1));
            });
            for (var k = 0; k < list.length; k++) {
                this.data.name[k] = list[k].n;
                this.data.location_id[k] = list[k].l;
            }
        }
    }
})
</script>

<template>
    <div class="iw-container">
        <span v-for="(locationId, index) in data.location_id"
              class="iw-location-name">
            <a :class="{'no-pointer': locationDataEmpty}"
               :href="locationDataEmpty ? undefined : `/system/client-status/${locationId}`"
            >{{ data.name[index] }}</a>
        </span>

        <div v-if="somePlayersActive"
             class="iw-flex-container">
            <client-status-icon :color="connectionStatus"
                                :title="t_connection" />
            <span>
                {{ t_connection }}:
                {{ data.connect_failures.errors }} {{ t_connect_failure_errors }},
                {{ data.connect_failures.warnings }} {{ t_connect_failure_warnings }}
                {{ t_for_players }}
            </span>
        </div>

        <div class="iw-flex-container">
            <client-status-icon :color="data.connect_failures.errors > 0 ? 'grey' : computedIconColor" />
            <span>
                <template v-if="somePlayersActive">
                    {{ this.data.fatals }} {{ this.t_fatal_errors }},
                    {{ this.data.errors }} {{ this.t_errors }},
                    {{ this.data.warnings }} {{ this.t_warnings }}
                    {{ this.t_for_players }}
                </template>
                <template v-else>{{ t_player_disabled }}</template>
            </span>
        </div>
        <div v-if="data.location_id.length"
             class="iw-button-container">
            <template v-if="!planEmpty">
                <template v-for="(locationId, index) in data.location_id">
                    <v-btn v-if="data.plan[index]"
                           small
                           @click="$emit('showPlan', locationId)">
                        <template v-if="moreThanOneLocationId">{{ t_show_plan }}: {{ data.name[index] }}</template>
                        <template v-else>{{ t_show_plan }}</template>
                    </v-btn>
                </template>
            </template>
        </div>

        <div v-for="client in data.clients"
             class="iw-flex-container">
            <div class="iw-status-container">
                <client-status-icon :color="client.inactive ? 'grey' : client.connection_status"
                                    :title="client.inactive ? t_disabled : t_connection" />
                <client-status-icon :color="client.connection_status === 'red' ? 'grey' : client.status"
                                    :title="t_status" />
            </div>
            <a :href="`/system/client-detail/${client.id}`"
            >{{ t_status }} {{ client.name }}</a>
        </div>
    </div>
</template>
